import { CircularPlayTransparentIcon } from '../../ui-lib/icons/circular-play-transparent'
import { CameraIcon } from '../../ui-lib/icons/camera'
import { EventIcon } from '../../ui-lib/icons/event'
import { LiveIcon } from '../../ui-lib/icons/live'
import { ReportIcon } from '../../ui-lib/icons/report'
import { TwoPersonsIcon } from '../../ui-lib/icons/two-persons'
import { OpenBookIcon } from '../../ui-lib/icons/open-book'
import { CustomerIcon } from '../../ui-lib/icons/customer'
import { PieGraphIcon } from '../../ui-lib/icons/pie-graph'
import { ResourceIcon } from '../../ui-lib/icons/resource'
import { CaseStudyIcon } from '../../ui-lib/icons/case-study'

import styles from './badge.module.scss'

type BadgeProps = {
  name: string
}

const BadgeIcon = ({ name }: BadgeProps) => {
  switch (name.toLowerCase()) {
    case 'webinar':
      return <CameraIcon />
    case 'event':
      return <EventIcon />
    case 'live':
      return <LiveIcon />
    case 'on demand':
      return <CircularPlayTransparentIcon />
    case 'report':
      return <ReportIcon />
    case 'resource':
      return <ResourceIcon />
    case 'in-person':
      return <TwoPersonsIcon />
    case 'case study':
      return <CaseStudyIcon />
    case 'ebook':
      return <OpenBookIcon />
    case 'customer story':
      return <CustomerIcon />
    case 'infographic':
      return <PieGraphIcon />
    default:
      return null
  }
}

export const Badge = ({ name }: BadgeProps) => {
  return (
    <div className={styles.badge}>
      <BadgeIcon name={name} />
      {name}
    </div>
  )
}
